import React from "react";
import cn from "classnames";

import { StyledCheckbox } from "../Checkbox/styles";
import { IProps } from "./interfaces";

const CheckboxThreeWay = ({ label, checked, disabled, onChange, name }: IProps) => {
    const toggle = () => {
        if (disabled) return;
        let changedChecked: boolean | undefined = checked;
        if (checked === true) changedChecked = false;
        else if (checked === false) changedChecked = undefined;
        else changedChecked = true;
        onChange({
            target: {
                type: "checkbox",
                name,
                checked: changedChecked,
            },
        });
    };

    return (
        <StyledCheckbox className={cn(disabled && "CheckboxDisabled")} tabIndex={0} onClick={toggle}>
            <div className={cn(
                "CheckboxMark",
                (checked === false || checked === true) && "CheckboxMarkChecked",
                checked === true && "CheckboxMarkChecked--true",
                checked === false && "CheckboxMarkChecked--false",
            )}>
                {checked === false && (
                    <svg width="15" height="15">
                        <line x1="2" x2="12" y1="2" y2="12" />
                        <line x1="12" x2="2" y1="2" y2="12" />
                    </svg>
                )}
                {checked === true && (
                    <svg width="15" height="15">
                        <polygon points="2,7 5,10 12,3 5,10" />
                    </svg>
                )}
            </div>
            <label className={"CheckboxLabel"}>{label}</label>
        </StyledCheckbox>
    );
}

export default CheckboxThreeWay;
